import React, { useEffect, useState } from 'react'
import Api from '../../../../_helpers/Api'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../_providers/Translation'
import PartsList from './PartsList'
import '../../../../assets/css/partials/status-diagram.css'
import '../../../../assets/css/partials/StoragePartsStats.css'
import { PieChart } from '@mui/x-charts'

export default function StoragePartsStats({
    endpoint = 'dashboard/storage-parts/stats',
    availabilityEndpoint = 'dashboard/storage-parts/availability',
    colors = ['#22C55E', '#3B82F6', '#8B5CF6', '#EF4444', '#F59E0B', '#EC4899', '#10B981', '#6366F1'],
    size = 220,
    donut = true
}) {
    // left side — existing stats API
    const [state, setState] = useState({ loading: true, data: null })

    useEffect(() => {
        let mounted = true
        Api.get(endpoint)
            .then(res => {
                if (!mounted) return
                setState({ loading: false, data: res?.data ?? res })
            })
            .catch(() => {
                if (mounted) setState({ loading: false, data: null })
            })
        return () => { mounted = false }
    }, [endpoint])

    const apiData = state.data || {}
    const recentParts = Array.isArray(apiData.recent_parts) ? apiData.recent_parts : []

    // right side — new availability API
    const [locationFilter, setLocationFilter] = useState('warehouse') // 'warehouse', 'van'
    const [availabilityState, setAvailabilityState] = useState({ loading: true, data: null })

    useEffect(() => {
        let mounted = true
        setAvailabilityState(prev => ({ ...prev, loading: true }))

        Api.get(`${availabilityEndpoint}?location_type=${locationFilter}`)
            .then(res => {
                if (!mounted) return
                setAvailabilityState({ loading: false, data: res?.data ?? null })
            })
            .catch(() => {
                if (mounted) setAvailabilityState({ loading: false, data: null })
            })

        return () => { mounted = false }
    }, [availabilityEndpoint, locationFilter])

    const availabilityData = Array.isArray(availabilityState.data?.parts_availability)
        ? availabilityState.data.parts_availability
        : []
    const availabilityTotal = availabilityState.data?.total_quantity ?? 0



    return (
        <div
            className="storage-parts-stats-chart"
        >
            <div className="head">
                <h3>{trans('tabs.parts')}</h3>
            </div>

            <hr />

            <div className="body">
                <div className="left">
                    <h5>{trans('random.recentlyAddedOrderedParts')}</h5>
                    <PartsList
                        recentParts={recentParts}
                        loading={state.loading}
                    />
                </div>
                <div className="right">
                    {availabilityState.loading ?
                        <Skeleton height={150} count={2} />
                        :
                        availabilityTotal === 0 ?
                            <div
                                className="alert info"
                                style={{
                                    width: '100%',
                                    marginBottom: "auto",
                                }}
                            >
                                {trans("messages.noDataFound")}
                            </div>
                            :
                            <div className='bot'>
                                <div className="bot-top">
                                    <h5>{trans('random.partsAvailability')}</h5>
                                    <div className="toggle-buttons">
                                        <button
                                            className={locationFilter === 'warehouse' ? 'active' : ''}
                                            onClick={() => setLocationFilter('warehouse')}
                                        >
                                            {trans('random.inWarehouse')}
                                        </button>
                                        <button
                                            className={locationFilter === 'van' ? 'active' : ''}
                                            onClick={() => setLocationFilter('van')}
                                        >
                                            {trans('labels.inVan')}
                                        </button>
                                    </div>
                                </div>
                                <div className="bot-chart">
                                    <PieChart
                                        series={[{
                                            data: availabilityData
                                                .filter(part => Number(part.quantity || 0) > 0)
                                                .map((part, index) => ({
                                                    id: index,
                                                    value: part.quantity || 0,
                                                    label: part.part_name,
                                                    color: colors[index % colors.length]
                                                })),
                                        }]}
                                        width={size}
                                        height={size}
                                        margin={{ right: 0 }}
                                        slotProps={{
                                            legend: { hidden: true },
                                        }}
                                    />
                                    <table>
                                        <tbody>
                                            {availabilityData.map((part, idx) => (
                                                <tr key={part.part_name || idx}>
                                                    <td>
                                                        <span style={{ backgroundColor: colors[idx % colors.length] }} />
                                                    </td>
                                                    <td><b>{part.part_name}</b></td>
                                                    <td>{part.quantity}</td>
                                                    <td>{part.percentage}%</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                    }
                </div>
            </div>

        </div>
    )
}